export const UPLOAD_IMAGE_REQUEST = "applicant/UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "applicant/UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "applicant/UPLOAD_IMAGE_FAILURE";

export const DOWNLOAD_FILE_REQUEST = "applicant/DOWNLOAD_FILE_REQUEST";
export const DOWNLOAD_FILE_SUCCESS = "applicant/DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "applicant/DOWNLOAD_FILE_FAILURE";
